import React from 'react';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth } from './Firebase';

const provider = new GoogleAuthProvider();

const LoginPage: React.FC = () => {
  const handleLogin = () => {
    signInWithPopup(auth, provider).catch(console.error);
  };

  return (
    <div className="login-container">
      <h2>Please sign in</h2>
      <button className="google-signin-button" onClick={handleLogin}>
        <img
          src="https://developers.google.com/identity/images/g-logo.png"
          alt="Google logo"
        />
        Sign in with Google
      </button>
    </div>
  );
};

export default LoginPage;
